'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ids$package$UserId$() {
  this.aUn = null;
  this.aUo = false;
  this.aUp = null;
  this.aUq = false;
}
export { $c_Lapp_data_ids$package$UserId$ as $c_Lapp_data_ids$package$UserId$ };
$p = $c_Lapp_data_ids$package$UserId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_ids$package$UserId$;
/** @constructor */
function $h_Lapp_data_ids$package$UserId$() {
}
export { $h_Lapp_data_ids$package$UserId$ as $h_Lapp_data_ids$package$UserId$ };
$h_Lapp_data_ids$package$UserId$.prototype = $p;
$p.aC = (function() {
  if ((!this.aUo)) {
    this.aUn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeULID__circeCodec__Lio_circe_Codec(this);
    this.aUo = true;
  }
  return this.aUn;
});
$p.bse = (function() {
  if ((!this.aUq)) {
    this.aUp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_Base64Id$().auo().bw("User ID");
    this.aUq = true;
  }
  return this.aUp;
});
var $d_Lapp_data_ids$package$UserId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ids$package$UserId$, "app.data.ids$package$UserId$", ({
  GN: 1,
  B: 1,
  C: 1,
  h8: 1
}));
export { $d_Lapp_data_ids$package$UserId$ as $d_Lapp_data_ids$package$UserId$ };
var $n_Lapp_data_ids$package$UserId$;
function $m_Lapp_data_ids$package$UserId$() {
  if ((!$n_Lapp_data_ids$package$UserId$)) {
    $n_Lapp_data_ids$package$UserId$ = new $c_Lapp_data_ids$package$UserId$();
  }
  return $n_Lapp_data_ids$package$UserId$;
}
export { $m_Lapp_data_ids$package$UserId$ as $m_Lapp_data_ids$package$UserId$ };
//# sourceMappingURL=app.data.ids$package$-User-Id$.js.map
